/* eslint-disable no-prototype-builtins */
/* eslint-disable no-self-compare */
import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef
} from "react";
import { ConfigProvider, Form, Row, Col } from "@tinper/next-ui";
import { useRefFunction } from "../../../utils/hooks/useRefFunction";
// import DataFormItem from "./DataFormItem.js";
import { EditOrReadOnlyContext, DataFormContext } from "./DataFormContext";
// TODO请求方法的临时实现，将来可能替换成统一方法
import { useWindowWidth } from "./DataFormHook";
import Submitter from "../../SearchForm/src/Submitter";
import { useSearchFormInstance } from "../../SearchForm/src/SearchFormHook";
import "./index.less";
// const InputType = DataFormItem.InputType;

const breakPointConfig = [0, 0, 600, 1080, 1360, 1920, Infinity];

function DataFormContent (props) {
  const {
    children,
    formLayout,
    submitter = false,
    contentRender,
    formRef,
    onReset,
    onSubmit,
    hiddenKeys: originHiddenKeys,
    invisibleKeys: originInvisibleKeys,
    requiredKeys,
    disabledKeys,
    disabled,
    fieldid,
    controlled,
    readOnly,
    locale
  } = props;
  // 自适应和流式布局
  // const { getBreakPoint } = useContext(ConfigProvider.ConfigContext);
  const [width] = useWindowWidth();
  const searchForm = useSearchFormInstance();
  let hasTooltip = false;
  let invisibleKeys = originInvisibleKeys;
  const hiddenKeys = useMemo(() => {
    if (Array.isArray(originHiddenKeys)) {
      return originHiddenKeys;
    } else if (originHiddenKeys && Object.keys(originHiddenKeys).length) {
      Object.keys(originHiddenKeys).forEach((key) => {
        const res = [];
        if (originHiddenKeys[key] === "destroy") {
          invisibleKeys ? invisibleKeys.push(key) : (invisibleKeys = [key]);
        } else if (
          originHiddenKeys[key] !== "visible" &&
          originHiddenKeys[key] !== false
        ) {
          res.push(key);
        }
        return res;
      });
    }
    return [];
  }, [originHiddenKeys]);
  const responsiveCol = useMemo(() => {
    if (Number(formLayout) === Number(formLayout)) { return Math.floor(formLayout); }
    const { width: containerWidth } =
      formRef.getFormContainer && formRef.getFormContainer();
    const wrapWidth = containerWidth || width;
    const index = breakPointConfig.findIndex((item) => item > wrapWidth) - 1;
    return index <= 1 ? 1 : index;
  }, [width, formLayout]);

  searchForm.setResponCol && searchForm.setResponCol(responsiveCol);
  // TODO FormItem传入的拓展属性
  const _extendFormProps = useRefFunction((target) => {
    const extraProps = {
      form: props?.formRef?.current || props.form,
      labelCol: props.labelCol,
      wrapperCol: props.wrapperCol,
      readOnly: props.readOnly,
      size: props.size,
      layout: props.layout,
      hasTooltip,
      controlled
    };
    if (target.props.required !== undefined) {
      extraProps.required = target.props.required;
    } else if (requiredKeys && requiredKeys.includes(target.props.name)) {
      extraProps.required = true;
    }
    if (target.props.disabled !== undefined) {
      extraProps.disabled = target.props.disabled;
    } else if (disabledKeys && disabledKeys.includes(target.props.name)) {
      extraProps.disabled = true;
    } else {
      extraProps.disabled = props.disabled;
    }

    if (target.props.labelCol) {
      extraProps.labelCol = target.props.labelCol;
    }

    if (target.props.wrapperCol) {
      extraProps.wrapperCol = target.props.wrapperCol;
    }
    if (target.props.readOnly) {
      extraProps.readOnly = target.props.readOnly;
    }
    if (target.props.inputType === "search") {
      extraProps.onSearch =
        target.props.onSearch || props.onSearch || props.onSubmit;
    }
    if (target.props.inputType === "rangepicker") {
      extraProps.getValueFromEvent =
        target.props.getValueFromEvent ||
        ((...args) => {
          const [start, end] = args[2] || [];
          if (!target.props.showTime && !target.props.format) {
            return [start.concat(" 00:00:00"), end.concat(" 23:59:59")];
          } else {
            return [start, end];
          }
        });
    }
    if (
      target.props.inputType === "date" ||
      target.props.inputType === "time"
    ) {
      extraProps.getValueFromEvent =
        target.props.getValueFromEvent ||
        ((...args) => {
          return args[1];
        });
    }
    if (extraProps.required && target.props.hidden !== "destroy") {
      formRef.requiredKeys.push(target.props.name);
    }
    formRef.fieldsProps[target.props.name] = Object.assign(
      {},
      target.props,
      extraProps
    );
    return extraProps;
  });
  /** 渲染提交按钮与重置按钮 */
  const submitterNode = useMemo(() => {
    if (submitter === false) return undefined;
    return (
      <Submitter
        key="submitter"
        {...submitter}
        onSubmit={onSubmit}
        onReset={(prevValues) => {
          submitter?.onReset?.(prevValues, formRef);
          onReset?.(prevValues, formRef);
        }}
        submitButtonProps={{
          ...submitter.submitButtonProps
        }}
        fieldid={fieldid}
        locale={locale}
      />
    );
  }, [submitter, onSubmit, fieldid]);
  const isDeepEqual = useRefFunction((obj1, obj2) => {
    if (obj1 === obj2) {
      return true;
    } else if (typeof obj1 === "object" && typeof obj2 === "object") {
      for (const key in obj1) {
        // 排除owner属性防止循环链表中的循环引用
        if (key !== '_owner' && obj1.hasOwnProperty(key) && !isDeepEqual(obj1[key], obj2[key])) {
          return false;
        }
      }
      return true;
    } else if (typeof obj1 === "function" || typeof obj2 === "function") {
      return true;
      // return obj1.toString() === obj2.toString();
    } else {
      return false;
    }
  });
  // 计算表单项属性变化
  const renderFormItemProps = useMemo(() => {
    if (Object.keys(formRef.fieldsProps).length === 0) return null;
    const diff = [];
    React.Children.forEach(children, (item, index) => {
      item.props && Object.keys(item.props).forEach((key) => {
        // 判读对象是否相等
        const itemProps = formRef.fieldsProps[item.props.name] || {};
        if (!isDeepEqual(item.props[key], itemProps[key])) {
          diff.push({
            name: item.props.name,
            key,
            value: itemProps[key],
            itemProps: item.props[key]
          });
        }
      });
    });
    return diff.length ? diff : null;
  }, [children]);

  // TODO formItem内容
  const renderFormItem = useMemo(() => {
    // TODO用户可能设置自定义的等分，改为从provider中获取
    const gridNum = 24;
    // 默认一行
    const colSpan = Math.floor(gridNum / responsiveCol);
    // TODO还需要判断label字数和width的关系
    const colViews = [];
    let totalSpan = 0;
    // 重置requiredKeys
    formRef.requiredKeys = [];

    const doCloneElement = function (target) {
      const props = _extendFormProps(target);
      return React.cloneElement(target, props);
    };
    if (children && children.length <= responsiveCol) {
      searchForm.setShowCollapsed && searchForm.setShowCollapsed(false);
    } else {
      searchForm.setShowCollapsed && searchForm.setShowCollapsed(true);
    }
    React.Children.forEach(children, (item, index) => {
      if (!React.isValidElement(item)) {
        console.warn("DataForm.Item is not a valid React element");
        return null;
      }
      if (item.props.tooltip) {
        hasTooltip = true;
      }
    });
    React.Children.map(children, (item, index) => {
      if (!React.isValidElement(item)) {
        console.warn("DataForm.Item is not a valid React element");
        return null;
      }

      let span = colSpan; // 默认布局一行N列
      if (item.props.colSpan) {
        let labelColSacle;
        span = item.props.colSpan;
        // eslint-disable-next-line prefer-const
        labelColSacle = (span * responsiveCol) / gridNum;
        item.props.labelColSacle = labelColSacle;
      }
      const colStyle = {};
      if (
        item.props.hidden === true ||
        item.props.hidden === "hidden" ||
        (hiddenKeys &&
          hiddenKeys.includes(item.props.name) &&
          item.props.hidden !== false &&
          item.props.hidden !== "visible")
      ) {
        colStyle.display = "none"; // 是否隐藏本单元
        if (item.props.originName) {
          item.props.name = item.props.originName;
        }
      } else if (
        item.props.hidden === "destroy" ||
        ((invisibleKeys && invisibleKeys.includes(item.props.name || item.props.originName)) &&
          item.props.hidden !== false &&
          item.props.hidden !== "visible")
      ) {
        colStyle.display = "none";
        if (item.props.name) {
          item.props.originName = item.props.name;
        }
        item.props.name = undefined; // 隐藏的单元不参与表单提交
      } else {
        // 临时处理不参与校验，等组件库支持后再修改
        if (item.props.originName) {
          item.props.name = item.props.originName;
        }
        totalSpan = totalSpan + span; // 注意：不显示的单元格不参与计算
      }
      colViews.push(
        <Col
          key={"dataItem_" + index + Math.random() + item.props.nid}
          span={span}
          style={colStyle}
        >
          {doCloneElement(item)}
        </Col>
      );
      if (item.props.rowBreak) {
        // 强制换行，注意需要补全上一行的空缺单元
        const spaceSpan = 24 - (totalSpan % 24); // 计算补全当前行需要填充的span值
        if (spaceSpan > 0 && spaceSpan < 24) {
          // 填充一个占位单元补全整行
          colViews.push(
            <Col
              span={spaceSpan}
              style={{ height: 45 }}
              dangerouslySetInnerHTML={{ __html: "&nbsp;" }}
            ></Col>
          );
          totalSpan = totalSpan + spaceSpan;
        }
      }
      // 提交按钮
      if (
        index === children.length - 1 &&
        !contentRender &&
        submitter.layout === "vertical"
      ) {
        colViews.push(
          <Col span={gridNum}>
            <Row key="submitter" justify="end" className="submitter">
              <Col span={colSpan}>
                <Row justify="end">
                  <Col style={{ display: "flex", "justify-content": "end" }}>
                    {submitterNode}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        );
      }
    });
    return colViews;
  }, [
    renderFormItemProps,
    submitterNode,
    hiddenKeys,
    invisibleKeys,
    requiredKeys,
    disabled,
    disabledKeys,
    readOnly,
    responsiveCol,
    controlled
  ]);

  const renderContent = useMemo(() => {
    const wrapItems = (
      <Row gutter={16} style={{ width: "100%" }}>
        {renderFormItem}
      </Row>
    );
    if (contentRender) {
      return contentRender(wrapItems, submitterNode);
    }
    return wrapItems;
  }, [renderFormItem, contentRender, submitterNode]);

  if (width === 0) return null;
  return <>{renderContent}</>;
}
function DataFormRoot (props, ref) {
  const [formInstance] = Form.useForm();
  const contextRef = useRef();
  const {
    children,
    // Form子组件支持的类型
    inputType,
    // 重置按钮的回调 <TODO>
    onReset,
    // form的ref
    form = formInstance,
    // 是否是只读状态
    readOnly,
    // 自定义样式
    className,
    // 表单初始化值，只生效一次
    initialValues,
    // 完全受控的值
    values,
    style = {},
    onValuesChange,
    hiddenKeys, // 隐藏的字段，依然会收集和校验字段
    invisibleKeys, // 不可见的字段，不会收集和校验字段
    ...propRest
  } = props;
  const formRef = useRef(props.formRef || form);
  // const searchForm = useSearchFormInstance();

  const extendRef = useMemo(() => {
    return {
      ...ref?.current,
      ...formRef.current,
      requiredKeys: [],
      fieldsProps: {},
      getFieldsProps: () => {
        return extendRef.fieldsProps;
      },
      getFormContainer: () => {
        return {
          width: contextRef.current?.offsetWidth,
          height: contextRef.current?.offsetHeight
        };
      },
      getRequiredFields: () => {
        return extendRef.requiredKeys;
      }
    };
  }, [ref, formRef.current, form, contextRef]);
  // 暴漏给外部ref的方法
  useImperativeHandle(
    ref,
    () => {
      return extendRef;
    },
    [ref, formRef.current]
  );
  const formContextValue = useMemo(() => {
    return {
      formRef: extendRef,
      formValues: values,
      contextName: "Value form DataForm DataFormContext Provider"
    };
  }, [ref, extendRef, values]);
  const onValuesChangeInner = (changedValues, allValues) => {
    formContextValue.formValues = { ...allValues, ...changedValues }
    if (onValuesChange) {
      onValuesChange(changedValues, allValues);
    }
  }

  useEffect(() => {
    if (values) {
      form.setFieldsValue(values);
    } else if (props.hasOwnProperty("values") && !values) {
      form.resetFields();
    }
  }, values);

  return (
    <EditOrReadOnlyContext.Provider
      value={{
        mode: props.readOnly ? "readonly" : "edit"
      }}
    >
      <ConfigProvider>
        <DataFormContext.Provider value={formContextValue}>
          <div
            ref={contextRef}
            style={{
              width: "100%",
              flex: "0 1 auto",
              ...style
            }}
            className={["as-dataForm", className].join(" ")}
          >
            {props.hidden && props.hidden === "destroy"
              ? null
              : (
                <Form
                  ref={extendRef}
                  form={form}
                  initialValues={{
                    ...initialValues
                  }}
                  {...propRest}
                  onValuesChange={onValuesChangeInner}

                >
                  <DataFormContent
                    {...props}
                    form={form}
                    formRef={extendRef}
                    initialValues={{
                      ...initialValues
                    }}
                    controlled={!!values}
                  ></DataFormContent>
                </Form>
              )}
          </div>
        </DataFormContext.Provider>
      </ConfigProvider>
    </EditOrReadOnlyContext.Provider>
  );
}
const DataForm = React.forwardRef(DataFormRoot);
DataForm.Provider = Form.Provider;

export default DataForm;
